import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/standalone-services-page.module.css'
// eslint-disable-next-line import/extensions
import valet from '../../json/trash-valet-data.json'

const valetServiceData = {
  name: 'Valet Trash and Recycling Service',
  description:
    'Doorstep valet trash and recycling collection for garden-style, mid-rise, and high-rise multifamily communities nationwide, including recycling, pet waste, breezeway checks, and dumpster-area cleanup.',
  serviceType: 'Valet Trash Service',
  url: 'https://getdimension.com/trash-valet',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Doorstep Trash Collection' },
    { name: 'Doorstep Recycling Collection' },
    { name: 'Pet Waste Station Service' },
    { name: 'Breezeway and Dumpster Area Cleanup' },
  ],
}

const valetFAQData = {
  questions: valet.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' ').replace(/<[^>]*>/g, ''),
  })),
}

function TrashValet() {
  return (
    <>
      <Head>
        <title>Valet Trash Service for Apartments | Dimension</title>
        <meta
          name="description"
          content="Doorstep valet trash and recycling pickup for garden, mid-rise, and high-rise communities nationwide. Five to seven nights a week, with breezeway and dumpster-area cleanup."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/trash-valet" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={valetServiceData} />
        <SchemaMarkup type="FAQPage" data={valetFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heading={valet.pitch.heading}
          material={valet.pitch.material}
          pitchText={valet.pitch.pitchText}
          ctaLink={valet.pitch.ctaLink}
          ctaText={valet.pitch.ctaText}
          ctaHeading="Ready to add valet trash to your community?"
          ctaSubtext="Share your property type, unit count, and what you need covered. Our team prepares a written, no-obligation quote — valet trash is priced per unit, never off a template."
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Clients />
        <FeatureList {...valet.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...valet.benefits} />
        <Approach {...valet.approach} />
        <FAQ {...valet.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Junk Removal',
              href: '/junk-removal',
              description:
                'Bulk item pickup and move-out cleanouts for the furniture and appliances valet routes do not cover.',
            },
            {
              label: 'Dumpster Rentals',
              href: '/dumpster-rental',
              description:
                'Roll-off containers for renovations, turns, and large-scale property cleanouts.',
            },
            {
              label: 'B2B Waste Solutions',
              href: '/b2b-solutions',
              description:
                'Portfolio-wide waste and recycling programs run through one account, one contact, and one set of reporting.',
            },
            {
              label: 'Sustainability Reporting',
              href: '/sustainability',
              description:
                'Diversion data and reporting that turn property waste activity into numbers owners can report on.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default TrashValet
